import React from 'react';
import { useTranslation } from 'react-i18next';
import './DossierLivestock.css';

export function DossierLivestock({ livestock = [] }) {
  const { t } = useTranslation();
  if (!livestock || livestock.length === 0) {
    return null;
  }

  return (
    <div className="dossier-livestock">
      <h4 className="dossier-livestock__title">{t('reports.workspace.dossier.sections.livestock.title')}</h4>
      
      <div className="dossier-livestock__list">
        {livestock.map((item) => (
          <div key={item.id} className="dossier-livestock__item">
            <div className="dossier-livestock__type">{item.type}</div>
            <div className="dossier-livestock__count">{item.count}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
